<om-label *ngIf="label || required" [text]="label ? label : ''" [isRequired]="required"></om-label>
<!-- readonly -->
<ng-container *ngIf="readonly; else rwMode">
  <div class="flexrow-nowrap-start gap-2">
    <span *ngFor="let dayOpt of _options$ | async; trackBy: _trackByValue" 
    [class]="(this.control?.value || '').includes(dayOpt.value) ? 'font-black' : 'font-light'">
      {{ dayOpt.label[0] }}
    </span>
  </div>
</ng-container>

<ng-template #rwMode>
  <nz-button-group>
    <button
      *ngFor="let dayOpt of _options$ | async; trackBy: _trackByValue"
      nz-button
      nzSize="small"
      [nzType]="selected.has(dayOpt.value) ? 'primary' : 'secondary'"
      (click)="_selectItem($event, dayOpt.value)"
    >
      {{ dayOpt.label[0] }}
    </button>
  </nz-button-group>
</ng-template>

<om-error [control]="control"></om-error>
